<template>
	<div>
		<s-crud
			title="Salida de Kit de Seguridad"
			:config="config"
			:filter="filter"
			edit
			remove
			@save="save($event)"
			ref="gridExitSeals"      
            @rowSelected="rowSelected($event)" 
			searchInput
			excel
		>
			<template v-slot:options>
				<v-btn
					text
					black
					@click="openAddDialog()"
					style="margin-top: 4px;"
				>
					<i class="mdi mdi-plus-circle-outline"></i>
				</v-btn>
			</template>
			<template v-slot:filter>
				<v-container>
					<v-col>
						<v-row justify="center">
							<v-col lg="3" class="s-col-form">
								<s-date label="Fecha Inicio" v-model="filter.SlsDateBegin"></s-date>
							</v-col>
							<v-col lg="3" class="s-col-form">
								<s-date label="Fecha Fin" v-model="filter.SlsDateEnd"></s-date>
							</v-col>
						</v-row>
					</v-col>
				</v-container>
			</template>

			<template scope="props">
				<v-container>
					<v-row v-if="props.item.SlsID" justify="center">
						<v-col cols="4" class="s-col-form">
						    <s-text label="OV" v-model="props.item.SlsOV"></s-text>
						</v-col>
                        <v-col cols="4" class="s-col-form">
                            <s-text label="Contenedor" v-model="props.item.SlsContainer"></s-text>
						</v-col>
					</v-row>
				</v-container>
			</template>

			<!-- <template v-slot:TkpStatus="{ row }">
				<v-chip 
					x-small 
					black
					:color="row.TkpStatusColor"
				>
					{{ row.TkpStatusName }}
				</v-chip>
			</template> -->

		</s-crud>
		<exit-seals-add-dialog v-model="addDialog" @saved="refreshGrid" />
	</div>
</template>

<script>
	import _sExitSealsService from '@/services/Logistics/LgsExitSealsService.js';
	import _sTaskService from '@/services/InformationTechnology/TaskService.js';
	import ExitSealsAddDialog from './ExitSealsAddDialog.vue';

	export default {
		components: {
			ExitSealsAddDialog
		},
		data() {
			return {
				itemSelected: null,
				filter: {},
				addDialog: false,
				config: {
					model: {
                        SlsID: "ID",
						SlsDate: "date",
					},
					service: _sExitSealsService,
					headers: [
						{text: "ID", value: "SlsID"},
						{text: "Requerimiento", value: "ReqDocumentNumber"},
						{text: "Área", value: "AreName"},
						{text: "Descripción", value: "DerDescription"},
						{text: "Cod. Kit Seguridad", value: "SlsCodeSeal"},
						{text: "Fecha", value: "SlsDate"},
						{text: "Contenedor", value: "SlsContainer"},
						{text: "OV", value: "SlsOV"},
						{text: "Nro Guia", value: "SlsNumberHarvestGuide"},
						{text: "Cod. Precinto", value: "SlsSealCode"},
					]
				},
				
			}
		},
		methods: {
			save(item) {
                console.log("item", item);
				item.save();
			},
            rowSelected(item)
			{
				if(item.length > 0)
				{
					this.itemSelected = item[0];
				}
			},
			openAddDialog() {
				this.addDialog = true;
			},
			refreshGrid() {
				this.$refs.gridExitSeals.refresh();
			}
		},
	}
</script>
